import { Component } from '@theme/component';

/**
 * @typedef {Object} ProductDescriptionReadMoreRefs
 * @property {HTMLElement} preview - Truncated preview content
 * @property {HTMLElement} full - Full description content
 * @property {HTMLButtonElement} toggle - Expand/collapse button
 */

/**
 * Toggles truncated product description between preview and full content.
 *
 * @extends {Component<ProductDescriptionReadMoreRefs>}
 */
class ProductDescriptionReadMore extends Component {
  requiredRefs = ['preview', 'full', 'toggle'];

  /**
   * Expands or collapses the description.
   *
   * @param {Event} event
   */
  toggle = (event) => {
    event.preventDefault();

    const expanded = this.dataset.expanded === 'true';
    const nextExpanded = (!expanded).toString();

    this.dataset.expanded = nextExpanded;
    this.refs.toggle.setAttribute('aria-expanded', nextExpanded);
    this.refs.full.toggleAttribute('hidden', expanded);
    this.refs.preview.toggleAttribute('hidden', !expanded);
  };
}

if (!customElements.get('product-description-read-more')) {
  customElements.define('product-description-read-more', ProductDescriptionReadMore);
}
